import React from 'react';

import ButtonListGroup from './buttonListGroup';

// items - array of button groups to render
export default ({ items = [] }) =>
  items.map((item) => (
    <ButtonListGroup key={`button-list-group-${item.title}`} list={item.list} title={item.title} />
  ));
